import React from 'react';
import ThreatsCardFake from './ThreatsCardFake';
import SecureStateCardFake from './SecureStateCardFake';
import FakeTextInfo from '../FakeTextInfo';
import styles from '../styles';

const SecureConnectionFake = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-4 col-xs-8">
          <FakeTextInfo height={56} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-8 col-xs-12">
          <FakeTextInfo height={25} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-8">
          <div className="row">
            <div className="col-sm-6 col-xs-8">
              <FakeTextInfo height={40} />
            </div>
          </div>
          <SecureStateCardFake numCards={3} />
          <SecureStateCardFake numCards={1} />
        </div>
        <div className="col-xs-12 col-sm-4">
          <div className="row">
            <div className="col-sm-8 col-xs-8">
              <FakeTextInfo height={40} />
            </div>
          </div>
          <ThreatsCardFake numItems={2} />
          <ThreatsCardFake numItems={2} />
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};
export default SecureConnectionFake;
